import React from "react";


export default function Subtitle2({ text }) {
    const colors = require("../../styles/Colors.json")
    return (
        <span style={{
           
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "21px",
            color: colors.colors.neutral02Color.neutral_02
        }}>{text}
        </span>
    )
}   